import moment from 'moment'

function enumerateDaysBetweenDates (startDate, endDate, inclusive) {
  const dates = []

  var currDate = moment(startDate).startOf('day')
  var lastDate = moment(endDate).startOf('day')
  if (inclusive) {
    dates.push(currDate.clone().format('YYYY-MM-DD'))
  }
  while (currDate.add(1, 'days').diff(lastDate) < 0) {
    dates.push(currDate.clone().format('YYYY-MM-DD'))
  }
  if (inclusive) {
    dates.push(currDate.clone().format('YYYY-MM-DD'))
  }
  return dates
}

function getRangeDays (initDay, finalDay) {
  const rangeDays = []

  if (initDay === finalDay) {
    rangeDays.push(initDay)
  }
  else if (initDay < finalDay) {
    for (let i = initDay; i <= finalDay; i++) {
      rangeDays.push(i)
    }
  }
  else {
    for (let i = initDay; i <= 6; i++) {
      rangeDays.push(i)
    }
    for (let i = 0; i <= finalDay; i++) {
      rangeDays.push(i)
    }
  }
  return rangeDays
}

function getDayOfWeek (name) {
  const days = [
    'SUNDAY',
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
  ]

  return days.indexOf(name)
}

export {
  enumerateDaysBetweenDates,
  getRangeDays,
  getDayOfWeek,
}
